import React from 'react';
import { addDays, format, startOfDay } from 'date-fns';

const TimelineHeader = ({ currentDate }) => {
    const daysToShow = 14; // Show 2 weeks for example
    const startDate = startOfDay(currentDate);

    const days = Array.from({ length: daysToShow }, (_, i) => addDays(startDate, i));

    return (
        <div className="timeline-header d-flex border-bottom" style={{ height: '40px' }}>
            {days.map(day => {
                const isToday = format(day, 'yyyy-MM-dd') === format(new Date(), 'yyyy-MM-dd');
                return (
                    <div
                        key={day.toISOString()}
                        className={`text-center border-end d-flex flex-column justify-content-center ${isToday ? 'bg-primary text-white' : ''}`}
                        style={{ minWidth: '100px', flex: 1 }}
                    >
                        <div className="fw-bold small">{format(day, 'EEE')}</div>
                        <div className="small">{format(day, 'd MMM')}</div>
                    </div>
                );
            })}
        </div>
    );
};

export default TimelineHeader;
